import React from 'react';
import styled from 'styled-components';
import { Colors, AnalyticsTag, AnalyticsProps, AnalyticsComponent } from '@inplayer-org/inplayer-ui';

const TabsContainer = styled.div`
  width: fit-content;
  margin: 2rem 0 0.5rem 0;
  display: flex;
  cursor: pointer;
`;

interface TabProps extends AnalyticsProps {
  active?: boolean;
}
const Tab = styled.div<TabProps>`
  border-bottom: ${({ active }) => active && `3px solid ${Colors.skyBlue}`};
  color: ${({ active }) => (active && `${Colors.skyBlue}`) || `${Colors.fontGray}`};
  padding: 0.5rem 1rem;
  display: inline-block;
  text-transform: uppercase;
  font-size: ${({ theme }) => theme.font.sizes.small};

  :hover {
    color: ${({ active }) => (active && `${Colors.skyBlue}`) || `${Colors.fontDarkGray}`};
  }
`;
const Wrapper = styled.div`
  font-size: 1.1rem;
  > svg {
    width: 1.5rem;
    height: 1.5rem;
  }
`;
interface Props {
  tabs: Array<{ name: string | JSX.Element; tag?: AnalyticsTag }>;
  onTabClick: (index: number) => void;
  selectedTabIndex: number;
}

const CustomTabNavigation: React.FC<Props> = ({ tabs, onTabClick, selectedTabIndex }) => {
  return (
    <TabsContainer data-tut="reactour__analytics-tabs">
      <AnalyticsComponent>
        {({ pages, tracker, merchantId, ip }) => (
          <>
            {tabs.map((tab, index) => (
              <Tab
                tag={tab.tag}
                key={index}
                onClick={() => {
                  tracker.track({
                    event: 'click',
                    type: 'tab',
                    tag: tab.tag || '',
                    pages,
                    merchantId,
                    ip,
                  });
                  onTabClick(index);
                }}
                active={selectedTabIndex === index}
              >
                <Wrapper>{tab.name}</Wrapper>
              </Tab>
            ))}
          </>
        )}
      </AnalyticsComponent>
    </TabsContainer>
  );
};

export default CustomTabNavigation;
